module.exports = __webpack_public_path__ + "static/acs-logo-transparent-1969740cc80ba9f0e14586d366c79130.svg";